(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3319],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 51196:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explorer/[type]",
      function () {
        return __webpack_require__(38344);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10633);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(87357);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11496);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23954);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82771);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34444);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9671);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40571);
/* harmony import */ var _redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41870);
/* harmony import */ var _sections_tag_TagItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6254);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ // @mui






// layouts

// components









// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        paddingBottom: theme.spacing(10),
        paddingTop: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15)
    });
});
// ----------------------------------------------------------------------
HomePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
function HomePage() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().translate;
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().themeStretch;
    var type = router.query.type;
    var title = type === "school" ? translate("label.school") : type === "plan" ? translate("label.plan") : translate("label.topic");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: title,
        description: translate("explorer.description"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                maxWidth: themeStretch ? "xl" : "lg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            variant: "h5",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            onClick: router.back,
                                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                width: 25,
                                                height: 25,
                                                icon: "solar:arrow-left-broken"
                                            }),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                children: translate("button.goBack")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            children: [
                                type === "school" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SchoolTags, {}),
                                type === "plan" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlanTags, {}),
                                type === "topic" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopicTags, {})
                            ]
                        })
                    ]
                })
            })
        })
    });
}
function SchoolTags() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.hackerthonTag;
    }), schools = ref.schools, search = ref.search, totalPages = ref.totalPages;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .getSchools */ .oX)());
    }, [
        search
    ]);
    //reset
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        return function() {
            dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, search), {
                page: 0
            })));
        };
    }, []);
    var handleChangePage = function(_, page) {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, search), {
            page: page - 1
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                container: true,
                children: schools.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 3,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_tag_TagItem__WEBPACK_IMPORTED_MODULE_10__/* .TagItemStyle1 */ .NS, {
                            tag: tag,
                            index: index
                        })
                    }, tag.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}
function PlanTags() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.hackerthonTag;
    }), plans = ref.plans, search = ref.search, totalPages = ref.totalPages;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .getPlans */ .qY)());
    }, [
        search
    ]);
    //reset
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        return function() {
            dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, search), {
                page: 0
            })));
        };
    }, []);
    var handleChangePage = function(_, page) {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, search), {
            page: page - 1
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                container: true,
                children: plans.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 2,
                        md: 3,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_tag_TagItem__WEBPACK_IMPORTED_MODULE_10__/* .TagItemStyle2 */ .nE, {
                            tag: tag,
                            index: index
                        })
                    }, tag.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}
function TopicTags() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.hackerthonTag;
    }), topics = ref.topics, search = ref.search, totalPages = ref.totalPages;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .getTopics */ .BB)());
    }, [
        search
    ]);
    //reset
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        return function() {
            dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, search), {
                page: 0
            })));
        };
    }, []);
    var handleChangePage = function(_, page) {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, search), {
            page: page - 1
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                children: topics.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_tag_TagItem__WEBPACK_IMPORTED_MODULE_10__/* .TagItemStyle3 */ .Bd, {
                        tag: tag,
                        index: index
                    }, tag.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 6254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bd": function() { return /* binding */ TagItemStyle3; },
/* harmony export */   "NS": function() { return /* binding */ TagItemStyle1; },
/* harmony export */   "nE": function() { return /* binding */ TagItemStyle2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11496);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41796);
/* harmony import */ var _utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87850);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34444);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65907);
/* harmony import */ var _components_Label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41451);
/* eslint-disable react/prop-types */ // @mui



// utils

// components




// ----------------------------------------------------------------------
var IconWrapperStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        width: 24,
        height: 24,
        display: "flex",
        borderRadius: "50%",
        alignItems: "center",
        justifyContent: "center",
        marginRight: theme.spacing(1),
        color: theme.palette.success.main,
        backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_7__/* .alpha */ .Fq)(theme.palette.success.main, 0.16)
    };
});
// ----------------------------------------------------------------------
function TagItemStyle1(param) {
    var tag = param.tag, index = param.index;
    var title = tag.title, _exerciseNo = tag.exerciseNo, exerciseNo = _exerciseNo === void 0 ? 0 : _exerciseNo, _acceptedNo = tag.acceptedNo, acceptedNo = _acceptedNo === void 0 ? 0 : _acceptedNo, _answerNo = tag.answerNo, answerNo = _answerNo === void 0 ? 0 : _answerNo, featureImage = tag.featureImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/tag/".concat(tag.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                cursor: "pointer",
                flexDirection: "row",
                alignItems: "center",
                p: 1,
                mt: 1,
                mb: 3,
                ml: {
                    sm: index % 4 === 0 ? 0 : 1
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    sx: {
                        flex: 1,
                        ml: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "subtitle2",
                            gutterBottom: true,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapperStyle, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        width: 16,
                                        height: 16,
                                        icon: "eva:trending-up-fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "subtitle2",
                                    component: "span",
                                    children: (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__/* .fPercent */ .f2)(acceptedNo * 100 / answerNo)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    component: "span",
                                    noWrap: true,
                                    sx: {
                                        color: "text.secondary"
                                    },
                                    children: "\xa0đ\xfang\xa0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "subtitle2",
                                    component: "span",
                                    children: [
                                        "/ ",
                                        (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__/* .fNumber */ .FK)(exerciseNo),
                                        " c\xe2u"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: featureImage,
                    sx: {
                        height: 90,
                        maxWidth: 90,
                        borderRadius: 0.5
                    },
                    alt: title
                })
            ]
        })
    });
}
//-------STYLE 2---------
function TagItemStyle2(param) {
    var tag = param.tag, index = param.index;
    var title = tag.title, _exerciseNo = tag.exerciseNo, exerciseNo = _exerciseNo === void 0 ? 0 : _exerciseNo, _acceptedNo = tag.acceptedNo, acceptedNo = _acceptedNo === void 0 ? 0 : _acceptedNo, _answerNo = tag.answerNo, answerNo = _answerNo === void 0 ? 0 : _answerNo, featureImage = tag.featureImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/tag/".concat(tag.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                cursor: "pointer",
                flexDirection: "row",
                alignItems: "center",
                p: 0,
                mt: 1,
                mb: 3,
                ml: {
                    sm: index % 4 === 0 ? 0 : 1
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: featureImage,
                    sx: {
                        height: 80,
                        width: 80
                    },
                    alt: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    sx: {
                        flex: 1,
                        ml: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "subtitle2",
                            gutterBottom: true,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "subtitle2",
                                    component: "span",
                                    children: (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__/* .fPercent */ .f2)(acceptedNo * 100 / answerNo)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    component: "span",
                                    noWrap: true,
                                    sx: {
                                        color: "text.secondary"
                                    },
                                    children: "\xa0đ\xfang\xa0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "subtitle2",
                                    component: "span",
                                    children: [
                                        "/ ",
                                        (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__/* .fNumber */ .FK)(exerciseNo),
                                        " c\xe2u"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// ----------------------------------------------------------------------
function TagItemStyle3(param) {
    var tag = param.tag;
    var title = tag.title, _exerciseNo = tag.exerciseNo, exerciseNo = _exerciseNo === void 0 ? 0 : _exerciseNo;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/tag/".concat(tag.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            sx: {
                px: 2,
                py: 0.5,
                cursor: "pointer",
                display: "inline-block",
                "&:hover": {
                    background: theme.palette.background.neutral
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                variant: "subtitle2",
                component: "span",
                children: [
                    title,
                    " ",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Label__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "filled",
                        color: "default",
                        children: (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__/* .fNumber */ .FK)(exerciseNo)
                    })
                ]
            })
        }, tag.id)
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,6429,633,6805,9774,2888,179], function() { return __webpack_exec__(51196); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);